/**
 * ID・パスワード変更画面のフォーム入力データを管理する state。
 * 入力画面から確認画面まで、新旧認証情報と「IDを変えない」選択状態を保持する。
 */
import { atom } from 'recoil';

/**
 * ID・パスワード変更フォームの入力データ型。
 */
export type IdPasswordChangeFormType = {
  /** ユーザーIDを変更しない場合はtrue */
  not_change_user_id: boolean;
  /** 新しいユーザーID */
  new_user_id: string;
  /** 現在のパスワード */
  current_password: string;
  /** 新しいパスワード */
  new_password: string;
  /** 新しいパスワード（確認用） */
  verify_password: string;
};

/** ID・パスワード変更入力内容を保持する state。 */
const IdPasswordChangeFormState = atom<IdPasswordChangeFormType>({
  key: 'IdPasswordChangeFormState',
  default: {
    not_change_user_id: false,
    new_user_id: '',
    current_password: '',
    new_password: '',
    verify_password: '',
  },
});

export { IdPasswordChangeFormState };
